import {
  ACCOUNT_CONTAINER_CENTRALIZED,
  ACCOUNT_FLYOUT_MODAL_ID,
  ACCOUNT_MODAL_OPEN_EVENT,
  WEB_PROMPT_MOBILE,
} from './constants';

export function setupLinkInterception(targetLink: string, callback: () => Promise<void> | void) {
  function preventAnchorRedirects(event: Event) {
    const target = event.target as Element;

    const link = target?.closest('a');

    if (link?.dataset?.['skipFlyout'] === 'true') {
      return;
    }

    if (link && link.href && link.href.includes(targetLink)) {
      event?.preventDefault();
      callback();
    }
  }

  function handleKeydown(event: Event) {
    if ((event as KeyboardEvent).key === 'Enter') {
      preventAnchorRedirects(event);
    }
  }

  function interceptAnchorClicks(id?: string) {
    let element: HTMLElement | Document = document;
    if (id) {
      const target = document.getElementById(id);
      if (target) {
        element = target;
      }
    }

    element.addEventListener('click', preventAnchorRedirects);

    element.addEventListener('keydown', handleKeydown);

    return () => {
      element.removeEventListener('click', preventAnchorRedirects);
      element.removeEventListener('keydown', handleKeydown);
    };
  }
  return { interceptAnchorClicks };
}

export function dispatchCustomEvent(isSwap: boolean, modalId?: string) {
  let addionals = {};
  const centralizedAccountFlyout = modalId === 'webPrompt';

  if (modalId) {
    if (['logout', 'sessionTimedOut', 'signIn'].includes(modalId)) {
      addionals = { flyoutOpenReason: modalId };
    } else if (modalId === 'webPrompt') {
      addionals = { flyoutType: WEB_PROMPT_MOBILE, newApproach: true };
    } else {
      addionals = { modalId };
    }
  }
  document.dispatchEvent(
    new CustomEvent(ACCOUNT_MODAL_OPEN_EVENT, {
      detail: {
        modalType: centralizedAccountFlyout ? ACCOUNT_CONTAINER_CENTRALIZED : ACCOUNT_FLYOUT_MODAL_ID,
        isSwap: isSwap,
        isFlyOut: true,
        ...(!centralizedAccountFlyout ? { isGlobalHeaderSignIn: true } : {}),
        ...addionals,
      },
    })
  );
}
